'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from 'src/components/PulseUI';
import { useAuth } from 'src/context/auth';
import { isSuperUser } from 'src/components/PermissionGuard/checks';
import type {
  EvidenceReasoning,
  WidgetEvidence,
} from 'src/api/redux/profileConfiguration/types';
import EvidenceTooltipContent from './EvidenceTooltipContent';

interface EvidenceInfoIconProps {
  evidence: EvidenceReasoning | WidgetEvidence;
  'data-testid'?: string;
}

const EvidenceInfoIcon: React.FC<EvidenceInfoIconProps> = ({
  evidence,
  'data-testid': testId = 'evidence-info-icon',
}) => {
  const { user } = useAuth();

  if (!isSuperUser(user)) return null;

  return (
    <Tooltip
      slotProps={{
        containerClassName:
          'bg-white border border-neutral-200 shadow-xl rounded-lg',
        contentClassName: 'min-w-72 max-w-96 max-h-72 overflow-y-auto p-3 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-neutral-300 [&::-webkit-scrollbar-track]:bg-transparent',
      }}
      content={<EvidenceTooltipContent evidence={evidence} />}
      position="left"
    >
      <div
        className="w-6 h-6 flex items-center justify-center cursor-pointer"
        data-testid={testId}
        aria-label="View AI evidence"
      >
        <Icon
          icon={faCircleInfo}
          className="text-sky-500 hover:text-sky-600 w-4 h-4"
          aria-hidden="true"
        />
      </div>
    </Tooltip>
  );
};

export default EvidenceInfoIcon;
